import { render, staticRenderFns } from "./FeesNoticeDetailsTableForm.vue?vue&type=template&id=58004d69"
import script from "./FeesNoticeDetailsTableForm.vue?vue&type=script&lang=js"
export * from "./FeesNoticeDetailsTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports